import axios from "axios";

const ROUTE_CODE_URI_PREFIX = "/v1/route-code";
const ROUTE_CODE_URIS = {
  GET_LIST_ROUTE_CODE: `${ROUTE_CODE_URI_PREFIX}/list`,
  EXPORT_LIST_ROUTE_CODE: `${ROUTE_CODE_URI_PREFIX}/export`
};

export default {
  getListRouteCode(params) {
    return axios.get(ROUTE_CODE_URIS.GET_LIST_ROUTE_CODE, { params });
  },
  deleteRouteCodes(params) {
    return axios.delete(`${ROUTE_CODE_URI_PREFIX}/delete/`, { params });
  },
  importRouteCodes(data) {
    return axios.post(`${ROUTE_CODE_URI_PREFIX}/import`, data);
  },
  exportRouterCode(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${ROUTE_CODE_URIS.EXPORT_LIST_ROUTE_CODE}?${searchParams.toString()}`;
    window.open(link);
  },
  downloadRouteCodesError(errorId) {
    return axios.get(`${ROUTE_CODE_URI_PREFIX}/download-error-file`, {
      responseType: "arraybuffer",
      params: {
        errorId,
      },
    });
  },
  downloadRouteCodesSuccess(errorId) {
    return axios.get(`${ROUTE_CODE_URI_PREFIX}/download-error-file`, {
      responseType: "arraybuffer",
      params: {
        errorId,
        type: 1,
      },
    });
  },

  // importContinueDriver(data) {
  //   return axios.post(DRIVER_URIS.IMPORT_CONTINUE, data);
  // },

  importRouteCodesSuccess(data) {
    return axios.post(`${ROUTE_CODE_URI_PREFIX}/import/finish`, data);
  },

  getDuplicatedRouteCodes(params) {
    return axios.get(`${ROUTE_CODE_URI_PREFIX}/import/confirm`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/services/routecode-service.js